import "./Switch.css";
import React, { useEffect } from "react";

import Schedule from "../visual/Schedule.js";

import {
  idRegex,
  getCoreScheduleSwitchUrl,
  getFullScheduleSwitchUrl,
} from "../../js/consts.js";
import { generateSharingUrl, showAlert, useQuery } from "../../js/utils.js";

import ShareUrl from "../smart/ShareUrl.js";

const schedDefault = {
  schedCategory: "",
  slots: [],
};

const Switch = () => {
  const query = useQuery();
  const urlTargetId = query.get("targetId");
  const previewScheduleRef = React.createRef();
  const [sourceId, setSourceId] = React.useState("");
  const [targetId, setTargetId] = React.useState("");
  const [switchType, setSwitchType] = React.useState("student-portal");

  const [sched, setSched] = React.useState(schedDefault);

  const onLoadSchedule = async () => {
    if (!idRegex.test(sourceId) || !idRegex.test(targetId)) {
      showAlert("Error", "Invalid ID provided");
      return;
    }

    previewScheduleRef.current.disabled = true;

    const url =
      switchType === "student-portal"
        ? getFullScheduleSwitchUrl
        : getCoreScheduleSwitchUrl;

    const params = new URLSearchParams();
    params.append("sourceId", sourceId);
    params.append("targetId", targetId);

    const response = await fetch(url + "?" + params.toString(), {
      method: "GET",
    }).catch((e) => {
      showAlert("Error", "Failed to get schedule\n" + e.toString());
      return null;
    });

    previewScheduleRef.current.disabled = false;

    if (!response) return;

    if (!response.ok) {
      showAlert("Error", "Failed to get schedule\n" + response.statusText);
      return;
    }

    const resp = await response.json();

    if (resp.status !== "ok") {
      showAlert("Error", resp.error);
      return;
    }

    const schedule = resp.data;

    setSched(schedule);
  };

  useEffect(() => {
    if (urlTargetId) {
      setTargetId(urlTargetId);
    }
  }, [urlTargetId]);

  const sharingUrl = generateSharingUrl(sourceId);

  return (
    <div className="container" style={{ margin: "10px" }}>
      <div id="title">Schedule Switching</div>
      <div id="switch-info">
        <div>
          Your Id
          <input
            type="text"
            className="id-input"
            placeholder="GUC ID"
            value={sourceId}
            onChange={(e) => setSourceId(e.target.value)}
          />
        </div>

        <div style={{ marginTop: "10px" }}>
          Switching with
          <input
            type="text"
            className="id-input"
            placeholder="GUC ID"
            value={targetId}
            onChange={(e) => setTargetId(e.target.value)}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            fontSize: "16px",
            margin: "5px 0 2px 0",
          }}
        >
          <div>Type:</div>
          <div>
            <div>
              <input
                type="radio"
                id="student-portal"
                value="student-portal"
                checked={switchType === "student-portal"}
                onChange={(e) => setSwitchType(e.target.value)}
              />
              <label for="student-portal">
                Online Student Portal (All Courses)
              </label>
            </div>

            <div>
              <input
                type="radio"
                id="student-affairs"
                value="student-affairs"
                checked={switchType === "student-affairs"}
                onChange={(e) => setSwitchType(e.target.value)}
              />
              <label for="student-affairs">
                Student Affairs (Core Courses Only)
              </label>
            </div>
          </div>
        </div>
        <button
          id="preview-schedule"
          ref={previewScheduleRef}
          onClick={onLoadSchedule}
          type="button"
        >
          Preview Schedule After Switch
        </button>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          color: "white",
          alignItems: "center",
          margin: "10px",
        }}
      >
        {!sharingUrl ? (
          <div class="share-text">
            Enter your GUC ID to get your schedule switching share link
          </div>
        ) : (
          <>
            {sourceId}'s schedule switching share link
            <ShareUrl url={sharingUrl} />
          </>
        )}
      </div>

      <Schedule schedule={sched} />
    </div>
  );
};

export default Switch;
